"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { AspectRatio } from "@/components/ui/aspect-ratio";
type Photo = {
  id: number;
  src: string;
  srcset?: string;
  alt: string;
  caption: string;
};
const kitchenPhotos: Photo[] = [{
  id: 1,
  src: "https://gn-construction.com/wp-content/uploads/2026/09/12964-3rd-St-Marketing-Media-Rental2.jpg",
  srcset: "https://gn-construction.com/wp-content/uploads/2026/09/12964-3rd-St-Marketing-Media-Rental2.jpg-wvc-srcset",
  alt: "Finished backyard ADU in Yucaipa with covered patio",
  caption: "ADU"
}, {
  id: 2,
  src: "https://gn-construction.com/wp-content/uploads/2026/09/gnc-riverside-detached-adu-after-1-1024x768.jpg",
  alt: "Finished detached ADU exterior in Riverside",
  caption: "Detached ADU"
}, {
  id: 3,
  src: "https://gn-construction.com/wp-content/uploads/2026/09/gnc-yucaipa-adu-after-1-1024x767.jpg",
  alt: "Finished ADU exterior in Yucaipa",
  caption: "ADU"
}, {
  id: 4,
  src: "https://gn-construction.com/wp-content/uploads/2026/09/gnc-riverside-detached-adu-after-3-1024x768.jpg",
  alt: "Finished ADU kitchen with island in Riverside",
  caption: "Detached ADU"
}, {
  id: 5,
  src: "https://gn-construction.com/wp-content/uploads/2026/09/gnc-riverside-adu-build-after-1-768x1024.jpg",
  alt: "Finished ADU kitchen with white cabinets in Riverside",
  caption: "ADU"
}, {
  id: 6,
  src: "https://gn-construction.com/wp-content/uploads/2026/09/gnc-yucaipa-adu-after-3-1024x576.jpg",
  alt: "Finished ADU living area in Yucaipa",
  caption: "ADU"
}, {
  id: 7,
  src: "https://gn-construction.com/wp-content/uploads/2026/09/gnc-riverside-detached-adu-after-4-1024x768.jpg",
  alt: "Finished ADU kitchen and living area in Riverside",
  caption: "Detached ADU"
}, {
  id: 8,
  src: "https://gn-construction.com/wp-content/uploads/2026/09/gnc-riverside-adu-build-after-3-1024x576.jpg",
  alt: "Finished ADU bathroom with tiled tub surround in Riverside",
  caption: "ADU"
}, {
  id: 9,
  src: "https://gn-construction.com/wp-content/uploads/2026/09/gnc-riverside-detached-adu-after-2-768x1024.jpg",
  alt: "Finished detached ADU in Riverside",
  caption: "Detached ADU"
}];
export default function KitchenGallery() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="kitchengallery" data-nav="light" className="bg-background text-foreground py-16 md:py-20 lg:py-24 border-b border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto mb-10 lg:mb-14">
          <span className="text-xs font-semibold uppercase tracking-[0.18em] text-primary mb-3">Finished projects</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold tracking-tight text-foreground mb-4">
            Completed ADUs
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground font-sans leading-relaxed">
            Finished ADUs from our projects in Riverside and Yucaipa.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
          {kitchenPhotos.map((photo, i) => <motion.figure key={photo.id} data-index={i} initial={shouldReduceMotion ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5,
          delay: shouldReduceMotion ? 0 : i % 3 * 0.08
        }} className="relative overflow-hidden rounded-xl border border-border shadow-xs bg-muted m-0">
              <AspectRatio ratio={4 / 3} className="w-full">
                <img src={photo.src} data-wvc-srcset={photo.srcset} data-wvc-sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw" alt={photo.alt} loading="lazy" decoding="async" className="h-full w-full object-cover object-center" />
              </AspectRatio>
              <figcaption className="absolute left-3 bottom-3 rounded-md bg-background/90 px-2.5 py-1 text-xs font-medium text-foreground shadow-sm">
                {photo.caption}
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}